
		<small [class]="val >= 0 ? 'text-success' : 'text-danger'">{{formatValue}}</small>
	